import { MutableRefObject } from 'react';
import { TChangeState, IHTMLTargetElement } from './interfaces';

export const handleOnClickCapture = (
  e: unknown,
  setVisible: TChangeState<boolean>,
  nodeElementCloseOnClick: string
) => {
  const shouldCloseOnClick =
    (e as IHTMLTargetElement)?.target?.nodeName?.toUpperCase() === nodeElementCloseOnClick.toUpperCase();

  if (shouldCloseOnClick) {
    setVisible((oldState: boolean) => !oldState);
  }
};

export const showTooltip = (
  setVisible: TChangeState<boolean>,
  timerRef: MutableRefObject<NodeJS.Timeout | undefined>,
  openTooltipWith: Array<string>
) => (event: unknown) => {
  const nameOfObject = (event as IHTMLTargetElement).target.nodeName;

  if (includesIn(nameOfObject, openTooltipWith)) {
    clearTimeout(timerRef.current as NodeJS.Timeout);
    return setVisible(true);
  }
};

export const closeTooltip = (setVisible: TChangeState<boolean>) => () => setVisible(false);

export const mouseLeaveTooltip = (
  setVisible: TChangeState<boolean>,
  timerRef: MutableRefObject<NodeJS.Timeout | undefined>
) => () => {
  clearTimeout(timerRef.current as NodeJS.Timeout);
  timerRef.current = setTimeout(closeTooltip(setVisible), 1500);
  return timerRef;
};

export const toggleTooltip = (visible: boolean, setVisible: TChangeState<boolean>, openTooltipWith: Array<string>) => (
  event: unknown
) => {
  const nameOfObject = (event as IHTMLTargetElement).target.nodeName;
  includesIn(nameOfObject, openTooltipWith) && setVisible(!visible);
};

export const includesIn = (nameOfObject: string, openTooltipWith: Array<string>) =>
  openTooltipWith?.some(name => name.toLowerCase() === nameOfObject.toLowerCase());
